import LanguageIcon from "@/assets/icons/language.svg";
import { Mention } from "@/types/Mention";
import TextButton, { TextButtonProps } from "@components/TextButton";

import { useEpisode } from "../../context";

const Translate: React.FunctionComponent<
  Omit<TextButtonProps, "icon" | "onClick"> & {
    mentions: Mention[];
    toKey?: keyof Mention;
  }
> = ({ mentions, toKey = "amended_text", ...props }) => {
  const { translateMention, unTranslateMention } = useEpisode();
  return (
    <TextButton
      {...props}
      icon={LanguageIcon}
      onClick={() => {
        for (const m of mentions) {
          m.translated
            ? unTranslateMention(m, toKey)
            : translateMention(m, toKey);
        }
      }}
      data-testid="translation-link"
    >
      {mentions[0].translated
        ? L.MENTIONS_SHOW_ORIGINAL
        : L.MENTIONS_SHOW_TRANSLATION}
    </TextButton>
  );
};

export default Translate;
